module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.article) ? _c('div', [_c('h1', [_vm._v("Figures")]), _vm._v(" "), _vm._l((_vm.article.files.figures), function(figure) {
    return _c('section', [_c('h2', [_vm._v(_vm._s(figure.label))]), _vm._v(" "), _c('div', [_c('img', {
      attrs: {
        "src": figure.url
      }
    })]), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(figure.caption)
      }
    })])
  })], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1419971f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/publications/article-detail/InteractFiguresPage.vue
// module id = 1393
// module chunks = 1